import { Box, Button, CircularProgress, Modal, TextField, Typography, Autocomplete, Pagination } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { orderApi } from "api/orders/orders";
import { userApi } from "api/user/user";
import OrderCard from "components/order/orderCard";
import OrderDetails from "components/order/orderDetails";
import { useUserContext } from "context/userContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Orders = () => {
    const { isAuth } = useUserContext();
    const [open, setOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const itemsPerPage = 5;

    const handleOpenOrderDetails = (order) => {
        navigate(`/orders/${order.id}`);
    };

    useEffect(() => {
        if (!isAuth) {
            navigate('/');
        }
    }, [isAuth, navigate]);

    useEffect(() => {
        setPage(1); 
      }, [searchTerm]);

    const { data: orders, isError, isLoading } = useQuery({
        queryFn: orderApi.get,
        queryKey: ["orders"],
    });

    if (isLoading) {
        return (
            <Box sx={{ width: 1, height: "90vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress sx={{ color: "gray" }} size={"50px"} />
            </Box>
        );
    }
    if (isError) {
        return <h1>Error occurred</h1>;
    }

    const orderRefs = orders?.data?.map((order) => order.order_ref) || [];
    const filteredOrders = orders?.data?.filter((order) =>
        order.order_ref.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalOrders = filteredOrders.length;
    const totalPages = Math.ceil(totalOrders / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedOrders = filteredOrders.slice(startIndex, startIndex + itemsPerPage);

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    width: 1,
                }}
            >
                <Typography sx={{ fontWeight: 700, fontSize: 20, mt: "20px", mb: "10px" }}>
                    Find dine ordredetaljer her
                </Typography>

                <Box display={"flex"} alignItems={"center"} justifyContent={"center"} width={"90%"} gap={2}>
                    <TextField
                        label="Søg ordrer ved hjælp af Rekv. nr."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{
                            height: "50px",
                            width: "100%",
                            mb: 2,
                            "& .MuiOutlinedInput-root": {
                                "&.Mui-focused fieldset": {
                                    borderColor: "#b7ab90",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                "&.Mui-focused": {
                                    color: "#b7ab90",
                                },
                            },
                        }}
                    />
                </Box>

                {paginatedOrders.map((order, key) => (
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                        }}
                        key={key}
                    >
                        <OrderCard onClick={() => handleOpenOrderDetails(order)} order={order} />
                    </Box>
                ))}

                {/* Pagination component */}
                {totalPages > 1 && (
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handleChangePage}
                        sx={{
                            mt: 2,
                            mb: 2,
                        }}
                    />
                )}
            </Box>
        </>
    );
};

export default Orders;
